export var SET_ALLOW_BACK_NAVIGATION = 'SET_ALLOW_BACK_NAVIGATION';
